export default {"src":"/_next/static/media/sw-logo-explore.a150a574.svg","height":295,"width":1398,"blurWidth":0,"blurHeight":0};